import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const CarouselItemSecondaryTestimonialCarouselItemBlock = ({
    author = null,
    carouselItemIndex = null,
    quote = null
}) => {
    // render
    return (
        <>
            {carouselItemIndex === 0 && (
                <div className='hidden md:block md:w-1/5 layout-grid-col-padding'/>
            )}

            <div className={`layout-grid-col-padding${carouselItemIndex === 0 ? ' w-12/12 md:w-4/5' : ' w-12/12'}`}>
                <div className='pr-35'>
                    <p className='type-style-4'>
                        Testimonial
                    </p>

                    <blockquote className='blockquote'>
                        {quote && (
                            <h3 className='type-style-3 mt-30'>
                                {quote}
                            </h3>
                        )}

                        {author && (
                            <cite className='block type-style-4 not-italic mt-30'>
                                {author}
                            </cite>
                        )}
                    </blockquote>
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

CarouselItemSecondaryTestimonialCarouselItemBlock.propTypes = {
    author: PropTypes.string.isRequired,
    carouselItemIndex: PropTypes.number.isRequired,
    quote: PropTypes.string.isRequired
};

export default CarouselItemSecondaryTestimonialCarouselItemBlock;
